import api from './axios';

export const adminLoginApi = (data) => api.post('/admin/auth/login', data);
export const adminRegisterApi = (data) => api.post('/admin/auth/register', data);
export const adminLogoutApi = () => api.post('/admin/auth/logout');
export const changePasswordApi = (data) => api.post('/admin/auth/change-password', data);
export const forgotPasswordApi = (data) => api.post('/admin/auth/forgot-password', data);
export const resetPasswordApi = (data) => api.post('/admin/auth/reset-password', data);
